import { ShoppingCartOutlined } from '@ant-design/icons';
import { Button, Empty, List, Typography } from 'antd';
import { ShoppingCart } from 'lucide-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { addOrderItem } from '../../../../redux/actions/order';
import { formatCurrency, getProductImageUrl } from '../../../../utils';

const { Text } = Typography;

const TabContent = ({ products = [] }) => {
    const { orderId } = useParams();
    const [loadingId, setLoadingId] = useState(null);

    const handleAddToOrder = async (product) => {
        try {
            setLoadingId(product.netsuite_id);
            if (product?.promo_price < product?.unit_price) product.unit_price = product.promo_price;

            const body = {
                id: product?.id,
                order_id: orderId,
                product_netsuite_id: product?.netsuite_id,
                quantity: 1,
                unit_price: product?.unit_price,
            };
            await addOrderItem(body, product);
        } finally {
            setLoadingId(null);
        }
    };

    return (
        <List
            className="offers-list h-full overflow-y-auto px-3  pb-0"
            itemLayout="horizontal"
            dataSource={products}
            locale={{
                emptyText: (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <Text type="secondary">No promotional offers available at the moment.</Text>
                        }
                    />
                ),
            }}
            renderItem={(product) => {
                const productImage = getProductImageUrl(product);

                return (
                    <List.Item key={product.netsuite_id} className="py-0 px-1 mb-1 shadow-1 border-round-lg">
                        <List.Item.Meta
                            className="align-items-center"
                            avatar={
                                productImage ? (
                                    <img
                                        src={productImage}
                                        alt={product.name}
                                        className="border-round-lg"
                                        style={{
                                            width: 60,
                                            height: 60,
                                            objectFit: 'cover',
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            width: 60,
                                            height: 60,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: '#fafafa',
                                            borderRadius: 8,
                                        }}
                                    >
                                        <ShoppingCartOutlined style={{ fontSize: 28, color: '#bbb' }} />
                                    </div>
                                )
                            }
                            title={
                                <Text ellipsis={{ tooltip: true }} strong>
                                    {product?.name}
                                </Text>
                            }
                            description={
                                <>
                                    <Text type="secondary">{product?.sub_category}</Text>
                                    <div className="flex justify-content-between align-items-center mb-1">
                                        <div className="flex align-items-center gap-2">
                                            <Text strong type="danger">
                                                {formatCurrency(product.promo_price)}
                                            </Text>
                                            <Text delete type="secondary">
                                                {formatCurrency(product.unit_price)}
                                            </Text>
                                        </div>
                                        <Button
                                            size="small"
                                            color="primary"
                                            variant="solid"
                                            icon={<ShoppingCart size={14} />}
                                            onClick={() => handleAddToOrder(product)}
                                            loading={loadingId === product.netsuite_id}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </>
                            }
                        />
                    </List.Item >
                );
            }}
        />
    );
};

export default TabContent;
